import { TableRow, TableCell, Paragraph, convertMillimetersToTwip } from "docx";

export default function generateLvTableHeadRow() {
  return new TableRow({
    tableHeader: true,
    cantSplit: true,
    children: [
      new TableCell({
        children: [new Paragraph({ text: "NR", bold: true })],
        margins: {
          top: convertMillimetersToTwip(1),
          bottom: convertMillimetersToTwip(1),
          left: convertMillimetersToTwip(1),
          right: convertMillimetersToTwip(1),
        },
      }),
      new TableCell({
        children: [new Paragraph({ text: "Leistungsbeschreibung", bold: true })],
      }),
      new TableCell({
        children: [new Paragraph({ text: "Menge", bold: true })],
      }),
      new TableCell({
        children: [new Paragraph({ text: "ME", bold: true })],
      }),
      new TableCell({
        children: [new Paragraph({ text: "EP", bold: true })],
      }),
      new TableCell({
        children: [new Paragraph({ text: "GP", bold: true })],
      }),
    ],
  });
}
